<template>
  <div class="block-counter-scroll-based-wrapper">
    <UtilWrapperLayout>
      <div
        ref="counterRef"
        class="block-counter-scroll-based"
      >
        <div class="block-counter-scroll-based__number is-narrow">
          <span>{{ currentNumber }}
            <template v-if="isMobile">
              <span>{{ mobile_suffix }}&nbsp;</span>
            </template>
            <span v-html="unit" /></span>
          <AtomRichtext :html="text" />
          <UtilRouteLink
            :link="link"
            class="block-counter-scroll-based__link"
          >
            <AtomButton :text="link_label" variant="inverted" />
          </UtilRouteLink>
        </div>
      </div>
    </UtilWrapperLayout>
  </div>
</template>

<script setup>
import { useWindowSize } from '@vueuse/core';

const props = defineProps({
    decimals: {
        type: Number,
        default: 0,
    },
    mobile_suffix: {
        type: String,
        default: '',
    },
    mobile_target: {
        type: Number,
        default: 0,
    },
    target: {
        type: Number,
        default: 0,
    },
    suffix: {
        type: String,
        default: '',
    },
    text: {
        type: Object,
        default: () => {},
    },
    unit: {
        type: String,
        default: '',
    },
    link: {
        type: Object,
        default: () => {},
    },
    link_label: {
        type: String,
        default: '',
    },
});

const counterRef = ref('counterRef');
const currentNumber = shallowRef(0);
const isMobile = ref(false);

const calculateNumber = (progress) => {
    const targetValue = isMobile.value ? props.mobile_target : props.target;
    const calculatedNumber = progress * targetValue;
    currentNumber.value = formatNumber(calculatedNumber.toFixed(props.decimals || 0));
};

const { width } = useWindowSize();

watch(() => width.value, (newValue) => {
    if (newValue < 750) {
        isMobile.value = true;
    } else {
        isMobile.value = false;
    }
});

onMounted(() => {
    isMobile.value = width.value < 750;

    const { createScrollTrigger } = useScrollTrigger();

    createScrollTrigger({
        trigger: counterRef.value,
        start: 'top bottom',
        end: '+=400%',
        onUpdate: (_self) => {
            calculateNumber(_self.progress);
        },
    });
});

const colorTopLevel = inject('colorSchema');
const colorText = computed(() => `var(--c-${colorTopLevel.value}-4)`);
const colorBackground = computed(() => `var(--c-${colorTopLevel.value}-6)`);
const color1 = computed(() => `var(--c-${colorTopLevel.value}-1)`);
</script>

<style lang="scss" scoped>
.block-counter-scroll-based-wrapper {
    background-color: v-bind(colorBackground);

    @include mobile {
        margin-top: -100%;
        margin-bottom: 100%;
    }
}

.block-counter-scroll-based {
    @include grid-layout();
    position: relative;
    width: 100%;
    height: 500vh;
    flex-direction: column;
    color: v-bind(colorText);
    grid-column-end: span calc(var(--grid-columns) - 2);
    grid-column-start: 2;
    @include fluid('padding-right', 0px, 60px);
    @include fluid('padding-left', 0px, 60px);

    .atom-richtext {
        color: var(--c-white);
    }
}

.block-counter-scroll-based__number {
    @include default-content-columns();
    @include fluid('font-size', 56px, 115px);
    @include fluid('line-height', 45px, 156px);

    position: sticky;
    top: 0;
    display: flex;
    height: 100vh;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    color: v-bind(color1);
    font-family: var(--f-family--black);
    opacity: v-bind(opacity);

    @include fluid('gap', 20px, 30px);
}
.block-counter-scroll-based__link {
    display: flex;
}
</style>
